import {
  DECYZJA_DO_KARTY_POBYTU,
  DOSTEP_DO_RYNKU_PRACY,
  KARTA_POBYTU,
  LEGITYMACIA,
  OSWIADCZENIE,
  PASSPORT,
  PESEL_UKR,
  VISA,
  ZASWIADCZENIE_Z_DZIEKANATY,
  ZEZWOLENIE_TYPY_A,
  ZGLOSZENIE_UKR,
} from "@/constants";
import { DocumentDecyziaDoKartyPobytu } from "../documents/document.decyzja_do_karty_pobytu";
import { DocumentKartPobytu } from "../documents/document.karta_pobytu";
import { DocumentLegitimacija } from "../documents/document.legitimacija";
import { DocumentPassport } from "../documents/document.passport";
import { DocumentPeselUKR } from "../documents/document.pesel_ukr";
import { DocumentVisa } from "../documents/document.visa";
import { DocumentZaswiadczenieZDziekanaty } from "../documents/document.zaswiadczenie_z_dekanatu";
import { DocumentZezwolenieTypyA } from "../documents/document.zezwolenie_typy_a";
import { DocumentZgloszenieUKR } from "../documents/document.zgloszenie_ukr";
import { FileComponent } from "../documents/file.component";
import { DocumentOswiadczenie } from "../documents/document.oswiadczenie";
import { DocumentDostempDoRynkuPracy } from "../documents/document.dostemp_do_rynku_pracy";

export const DocumentViewComponent = (props) => {
  const { id, document } = props;
  const typeOfDocument = document.entityType;
  const files = document.files;

  return (
    <div className="w-full md:w-12/12 lg:w-8/12 xl:w-5/12">
      {typeOfDocument === PASSPORT && <DocumentPassport document={document} />}
      {typeOfDocument === VISA && <DocumentVisa document={document} />}

      {typeOfDocument === PESEL_UKR && <DocumentPeselUKR document={document} />}

      {typeOfDocument === LEGITYMACIA && (
        <DocumentLegitimacija document={document} />
      )}

      {typeOfDocument === ZEZWOLENIE_TYPY_A && (
        <DocumentZezwolenieTypyA document={document} clientId={id} />
      )}

      {typeOfDocument === ZASWIADCZENIE_Z_DZIEKANATY && (
        <DocumentZaswiadczenieZDziekanaty document={document} />
      )}

      {typeOfDocument === KARTA_POBYTU && (
        <DocumentKartPobytu document={document} />
      )}

      {typeOfDocument === DECYZJA_DO_KARTY_POBYTU && (
        <DocumentDecyziaDoKartyPobytu document={document} />
      )}

      {typeOfDocument === ZGLOSZENIE_UKR && (
        <DocumentZgloszenieUKR document={document} />
      )}

      {typeOfDocument === OSWIADCZENIE && (
        <DocumentOswiadczenie document={document} clientId={id} />
      )}

      {typeOfDocument === DOSTEP_DO_RYNKU_PRACY && (
        <DocumentDostempDoRynkuPracy document={document} clientId={id} />
      )}

      <div className="pt-8 pb-4 text-xl">Files</div>
      <div className=" pb-8">
        <FileComponent files={files} clinetId={id} />
      </div>
    </div>
  );
};
